import type {
  FormBlock,
  FormDisplayBlock,
  FormResult,
  FormValue,
  FormValues,
} from '@/components/UI/Form/types'

export function addResponsesToFormBlocks({
  blocks,
  responses,
  Component,
}: {
  blocks: FormBlock[]
  responses: FormValues
  Component?: React.ComponentType<{ input: FormResult }>
}): (FormResult | FormDisplayBlock)[] {
  return blocks.map(block => {
    if (block.display === 'display') {
      return block
    }
    const result: FormResult = {
      ...block,
      display: 'result',
      response: responses[block.name] != null ? `${responses[block.name]}` : null,
      Component,
    }
    return result
  })
}

export function isCorrectAnswer({
  input,
  response,
}: {
  input: FormBlock
  response: FormValue
}): null | boolean {
  if (input.type === 'content') {
    return null
  }
  if (input.metadata?.answers == null || input.metadata.answers.length === 0) {
    return null
  }

  return input.metadata.answers.includes(response)
}
